import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastyService, ToastyConfig, ToastyComponent, ToastOptions, ToastData } from 'ng2-toasty';
import { ToastService } from './services/shared/toastservice';

@Component({
  selector: 'app-root',
  template: '<router-outlet><spinner></spinner><ng2-toasty></ng2-toasty></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(translate: TranslateService, private toastyService: ToastyService, private toastService: ToastService) {
    translate.addLangs(['en', 'se']);
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('se');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    var localId = sessionStorage.getItem('localeId');
    if (localId != null) {
      translate.use(sessionStorage.getItem('localeId'));
    }
  }

  ngOnInit() {
    this.toastService.changeEmitted$.subscribe(
      (notifyObject) => {
        this.addToast(notifyObject);
      });
  }

  addToast(notifyObject) {
    var toastOptions: ToastOptions = {
      title: notifyObject.title,
      msg: notifyObject.msg,
      showClose: true,
      timeout: 5000,
      theme: 'default',
      onAdd: (toast: ToastData) => {
        //console.log('Toast ' + toast.id + ' has been added!');
      },
      onRemove: function (toast: ToastData) {
        //console.log('Toast ' + toast.id + ' has been removed!');
      }
    };

    switch (notifyObject.type) {
      case 'default': this.toastyService.default(toastOptions); break;
      case 'info': this.toastyService.info(toastOptions); break;
      case 'success': this.toastyService.success(toastOptions); break;
      case 'wait': this.toastyService.wait(toastOptions); break;
      case 'error': this.toastyService.error(toastOptions); break;
      case 'warning': this.toastyService.warning(toastOptions); break;
    }
  }
}



// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/app.component.ts